import { useCircleSize, useTheme, useRadiusSize } from "arkh";
import styles from "./PrioAnimations.module.css";

export default function PrioAnimation() {
  const size = useCircleSize("small");
  const theme = useTheme();
  const cr = useRadiusSize("small");

  return (
    <div
      style={{
        width: size,
        height: size,
        backgroundColor: theme.negative,
        animationName: styles.Pulse,
        borderRadius: cr,
      }}
      className={styles.PrioAnimation}
    />
  );
}
